// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YtIkduOEW2 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.YtIkduOEW2 h4 {
  line-height: 3em;
}
.YtIkduOEW2 .NRO6s6AXP2 {
  float: left;
  width: 100%;
}
.YtIkduOEW2 .yhwET4bPWW {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.YtIkduOEW2 .yhwET4bPWW:hover {
  cursor: pointer;
}
.YtIkduOEW2 .yhwET4bPWW:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.u6IFC8pc6J .Trcy1hY3qK:focus {
  outline: none;
}
.u6IFC8pc6J .Trcy1hY3qK.Mr3L_63b63.JshmglyH4O {
  background: #375A88;
}
.u6IFC8pc6J .Trcy1hY3qK.Mr3L_63b63.JshmglyH4O span {
  color: #fff;
}
.u6IFC8pc6J .JshmglyH4O {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.u6IFC8pc6J .JshmglyH4O:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.u6IFC8pc6J input {
  height: 38px;
  min-width: 220px;
}
.yhwET4bPWW.TYQhluEHRJ {
  background: #410102;
}
.yhwET4bPWW.xj68WwSzi8 {
  background: #911318;
}
.yhwET4bPWW.LK_zz1HCAM {
  background: #D8293B;
}
.yhwET4bPWW.NGn0_GwCuj {
  background: #F2373C;
}
.yhwET4bPWW.o1bUetPYoz {
  background: #FC4448;
}
.yhwET4bPWW.ju8wMZrUJH {
  background: #ED535E;
}
.yhwET4bPWW.t9zq3OSbs4 {
  background: #E34926;
}
.yhwET4bPWW.BfAoMfG3Ad {
  background: #FC562B;
}
.yhwET4bPWW.lnLqmv31L1 {
  background: #FC6722;
}
.yhwET4bPWW.zqiaO1j4ef {
  background: #FD7F24;
}
.yhwET4bPWW.gxpZvpSZ2k {
  background: #FD8D26;
}
.yhwET4bPWW.KpAmfeK6Fz {
  background: #EC9C3E;
}
.yhwET4bPWW.XxUuCMn4pZ {
  background: #0e673a;
}
.yhwET4bPWW.l_SLZqVitL {
  background: #208740;
}
.yhwET4bPWW.J7MUb99Jjr {
  background: #239718;
}
.yhwET4bPWW.IV2p8LwizY {
  background: #55A84D;
}
.yhwET4bPWW.IuwdxDfWvn {
  background: #4BBE5A;
}
.yhwET4bPWW.dgcN2auQK4 {
  background: #0CCA6A;
}
.yhwET4bPWW.FvwSYkpkyh {
  background: #0A3C64;
}
.yhwET4bPWW.cM3IilFs4f {
  background: #0d487a;
}
.yhwET4bPWW.DobD78B4ip {
  background: #10538d;
}
.yhwET4bPWW.UsW0vabkJ8 {
  background: #115A99;
}
.yhwET4bPWW.i13U3bl3tW {
  background: #3387E2;
}
.yhwET4bPWW.SJH869Ha6o {
  background: #1BA9CF;
}
.yhwET4bPWW.rtMsgEY4bt {
  background: #d27c02;
}
.yhwET4bPWW.sGDd60WXZ7 {
  background: #fb9402;
}
.yhwET4bPWW.yQcKnwVFgz {
  background: #FD9B30;
}
.yhwET4bPWW.vhN_AHERKz {
  background: #FDBE2D;
}
.yhwET4bPWW.gKFQjyKE9Q {
  background: #FED831;
}
.yhwET4bPWW.RC4utXWaLY {
  background: #FFFD38;
}
.yhwET4bPWW.cXTQ0WrKPV {
  background: #2D215C;
}
.yhwET4bPWW.NAnOIDhKkl {
  background: #483C83;
}
.yhwET4bPWW.AJmkGiMpRT {
  background: #58518d;
}
.yhwET4bPWW.RBkEDrK79q {
  background: #7068A9;
}
.yhwET4bPWW.AV_8jOqcCv {
  background: #7f78b2;
}
.yhwET4bPWW.CUWBPx3BI_ {
  background: #8f88bc;
}
.yhwET4bPWW.ExpvRQQMTo {
  background: #000;
}
.yhwET4bPWW.DAqd5I9B4I {
  background: #282626;
}
.yhwET4bPWW.LvsImWEQXf {
  background: #242222;
}
.yhwET4bPWW.iTkjJLIGl7 {
  background: #353838;
}
.yhwET4bPWW.gJeeBIKeKX {
  background: #666;
}
.yhwET4bPWW.SRn6ujHjRp {
  background: #999;
}
.FZ6HRUrxrn {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.FZ6HRUrxrn .tHHChTJZl7 {
  display: none;
}
.LNlp301gPU {
  display: flex;
  justify-content: space-between;
  height: 490px;
  max-width: 948px;
  overflow: hidden;
}
.JG3CaQRR8f {
  min-width: 240px;
  background-color: #f5f6fa;
  padding-top: 28px;
  overflow-y: scroll;
}
.JG3CaQRR8f::-webkit-scrollbar {
  width: 8px;
}
.JG3CaQRR8f::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
.uBF94vqKnM {
  font-size: 11px;
  text-transform: uppercase;
  margin-left: 24px;
}
.Ec22RNmlfi {
  background-color: #fff;
  margin: 0 24px 32px 24px;
  border-radius: 4px;
  overflow: hidden;
}
.Ec22RNmlfi .ZOra2jlxcM {
  object-fit: contain;
  min-height: 225px;
  min-width: 170px;
}
.Ec22RNmlfi .UVLiguVi5E {
  color: black;
  font-weight: 700;
  padding: 4px 8px;
}
.Ec22RNmlfi .UVLiguVi5E .t7bub6Hs7J {
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 168px;
}
.Ec22RNmlfi .nuzw0uVl7E {
  border-radius: 4px 4px 0 0;
  background: #d9d9d9;
}
.Ec22RNmlfi .TPawAuGdBa {
  margin-left: 2px;
  text-decoration: underline;
}
.Z9OugVIXPo {
  background-color: #fff;
  margin: 0 28px 28px 26px;
  padding: 8px;
  text-align: center;
}
.Z9OugVIXPo .LhtGJpROxh {
  color: #383D41;
  font-size: 115px;
}
.Z9OugVIXPo .sag5r6RnK9 {
  display: block;
}
.Z9OugVIXPo .sag5r6RnK9 .VjjksOkror {
  font-size: 11px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.e3t99QzwhO {
  position: relative;
  min-width: 706px;
}
.e3t99QzwhO .yXLB1YHOV8 .X1bmDdUHxj {
  padding-left: 24px;
}
.e3t99QzwhO .yXLB1YHOV8 .X1bmDdUHxj .UbJdJ7ep57 {
  font-weight: bold;
}
.e3t99QzwhO .yXLB1YHOV8 .X1bmDdUHxj .mINb3aR6x5 {
  color: #999999;
}
.e3t99QzwhO .t1aKVtPNU_ {
  height: 24px;
  font-size: 11px;
  position: absolute;
  right: 18px;
  top: 24px;
  background-color: #00a8a5;
}
.Nz_4qoVCeg {
  min-width: fit-content;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `YtIkduOEW2`,
	"color-row": `NRO6s6AXP2`,
	"color-tile": `yhwET4bPWW`,
	"picker-component": `u6IFC8pc6J`,
	"picker-element": `Trcy1hY3qK`,
	"active": `Mr3L_63b63`,
	"btn": `JshmglyH4O`,
	"red-1": `TYQhluEHRJ`,
	"red-2": `xj68WwSzi8`,
	"red-3": `LK_zz1HCAM`,
	"red-4": `NGn0_GwCuj`,
	"red-5": `o1bUetPYoz`,
	"red-6": `ju8wMZrUJH`,
	"orange-1": `t9zq3OSbs4`,
	"orange-2": `BfAoMfG3Ad`,
	"orange-3": `lnLqmv31L1`,
	"orange-4": `zqiaO1j4ef`,
	"orange-5": `gxpZvpSZ2k`,
	"orange-6": `KpAmfeK6Fz`,
	"green-1": `XxUuCMn4pZ`,
	"green-2": `l_SLZqVitL`,
	"green-3": `J7MUb99Jjr`,
	"green-4": `IV2p8LwizY`,
	"green-5": `IuwdxDfWvn`,
	"green-6": `dgcN2auQK4`,
	"blue-1": `FvwSYkpkyh`,
	"blue-2": `cM3IilFs4f`,
	"blue-3": `DobD78B4ip`,
	"blue-4": `UsW0vabkJ8`,
	"blue-5": `i13U3bl3tW`,
	"blue-6": `SJH869Ha6o`,
	"yellow-1": `rtMsgEY4bt`,
	"yellow-2": `sGDd60WXZ7`,
	"yellow-3": `yQcKnwVFgz`,
	"yellow-4": `vhN_AHERKz`,
	"yellow-5": `gKFQjyKE9Q`,
	"yellow-6": `RC4utXWaLY`,
	"purple-1": `cXTQ0WrKPV`,
	"purple-2": `NAnOIDhKkl`,
	"purple-3": `AJmkGiMpRT`,
	"purple-4": `RBkEDrK79q`,
	"purple-5": `AV_8jOqcCv`,
	"purple-6": `CUWBPx3BI_`,
	"black-1": `ExpvRQQMTo`,
	"black-2": `DAqd5I9B4I`,
	"black-3": `LvsImWEQXf`,
	"black-4": `iTkjJLIGl7`,
	"black-5": `gJeeBIKeKX`,
	"black-6": `SRn6ujHjRp`,
	"picker-theme": `FZ6HRUrxrn`,
	"arrow-regular": `tHHChTJZl7`,
	"review-setting": `LNlp301gPU`,
	"review-setting__assets": `JG3CaQRR8f`,
	"review-setting__assets--label": `uBF94vqKnM`,
	"review-setting__assets--thumbnail": `Ec22RNmlfi`,
	"assets__thumbnail__img": `ZOra2jlxcM`,
	"assets-thumbnail__info": `UVLiguVi5E`,
	"thumbnail-info__url": `t7bub6Hs7J`,
	"thumbnail__img--readyUrl": `nuzw0uVl7E`,
	"thumbnail-info__tooltip": `TPawAuGdBa`,
	"review-setting__assets--url": `Z9OugVIXPo`,
	"asset__url--img": `LhtGJpROxh`,
	"asset__url--ctn": `sag5r6RnK9`,
	"asset__url--text": `VjjksOkror`,
	"review-setting__content": `e3t99QzwhO`,
	"tab-root": `yXLB1YHOV8`,
	"tab-root__flexContainer": `X1bmDdUHxj`,
	"tab-root__selected": `UbJdJ7ep57`,
	"tab-root__disabled": `mINb3aR6x5`,
	"chip-round": `t1aKVtPNU_`,
	"review-setting__tooltip": `Nz_4qoVCeg`
};
export default ___CSS_LOADER_EXPORT___;
